import { useCallback } from 'react'

import { useTribeClient } from '../../useTribeClient.js'

export const useGetCalendarInvite = () => {
  const { client } = useTribeClient()

  const getCalendarInvite = useCallback(
    async (eventId: string) => {
      return client.events.getCalendarInviteData({ eventId })
    },
    [client],
  )

  return {
    getCalendarInvite,
  }
}
